import React from "react";
import "./cardHeader.css";

const CardHeader = ({ banner, avatar, name, jobPosition }) => {
  return (
    <div className="card-header">
      <div className="logo-banner">
        <img src={banner} alt="GC Flooring Logo" className="logo" />
      </div>
      <img src={avatar} alt="Tedi profile pic" className="profile-image" />
      <h1>{name}</h1>
      <h2>{jobPosition}</h2>
    </div>
  );
};

export default CardHeader;
